export default {"src":"/_next/static/media/showcase-nrw-logo-white.37e6ea61.svg","height":72,"width":151,"blurWidth":0,"blurHeight":0};